<template>
    <div v-if="errorsArr.length > 0">
        <UAlert color="error" variant="subtle">
            <template #description>
                <p v-for="(error, index) in errorsArr" :key="index" class="mb-2 last:mb-0">{{ error }}</p>
            </template>
        </UAlert>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{
        errors?: string | string[];
    }>();

    const errorsArr = ref<string[]>([]);

    watch(
        () => props.errors,
        () => {
            errorsArr.value = props.errors == null ? [] : isStringArray(props.errors) ? props.errors : [props.errors];
        },
        { immediate: true },
    );
</script>
